'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _animationEnd$animati;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*

  Declare and export all constants here

  e.g.

  export default {
    openInlineCart: 'BVA.OPEN_INLINE_CART',
    closeInlineCart: 'BVA.CLOSE_INLINE_CART',
  };

*/

exports.default = (_animationEnd$animati = {
  animationEnd: 'BVA.ANIMATION.END',
  animationStart: 'BVA.ANIMATION.START',

  addToCart: 'BVA.CART.ADD',
  removeFromCart: 'BVA.CART.REMOVE',
  updateCart: 'BVA.CART.UPDATE',
  cartRequestError: 'BVA.CART.REQUEST.ERROR',
  cartRequestSuccess: 'BVA.CART.REQUEST.SUCCESS',

  openInlineCart: 'BVA.INLINE_CART.OPEN',
  closeInlineCart: 'BVA.INLINE_CART.CLOSE',
  toggleInlineCart: 'BVA.INLINE_CART.TOGGLE',
  updateInlineCartUI: 'BVA.INLINE_CART.UPDATE',

  updateInventory: 'BVA.INVENTORY.UPDATE',

  hideModal: 'BVA.MODAL.HIDE',
  showModal: 'BVA.MODAL.SHOW',
  openModal: 'BVA.MODAL.OPEN',
  closeModal: 'BVA.MODAL.CLOSE',
  toggleModal: 'BVA.MODAL.TOGGLE',

  showOverlay: 'BVA.OVERLAY.SHOW',
  hideOverlay: 'BVA.OVERLAY.HIDE',

  updateOptionGroupValue: 'BVA.OPTION_GROUP.UPDATE',

  updatePrice: 'BVA.PRICE.UPDATE',

  updateQuantity: 'BVA.QUANTITY.UPDATE',
  updateProductQuantity: 'BVA.QUANTITY.UPDATE.PRODUCT',
  updateLineItemQuantity: 'BVA.QUANTITY.UPDATE.LINE_ITEM',

  updateState: 'BVA.STATE.UPDATE'
}, (0, _defineProperty3.default)(_animationEnd$animati, 'updateCart', 'BVA.STATE.UPDATE.CART'), (0, _defineProperty3.default)(_animationEnd$animati, 'updateStatePrice', 'BVA.STATE.UPDATE.PRODUCT.PRICE'), (0, _defineProperty3.default)(_animationEnd$animati, 'toggle', 'BVA.TOGGLE'), (0, _defineProperty3.default)(_animationEnd$animati, 'updateVariant', 'BVA.VARIANT.UPDATE'), (0, _defineProperty3.default)(_animationEnd$animati, 'updateVariantId', 'BVA.VARIANT.UPDATE.ID'), (0, _defineProperty3.default)(_animationEnd$animati, 'openQuickshop', 'BVA.QUICKSHOP.OPEN'), (0, _defineProperty3.default)(_animationEnd$animati, 'closeQuickshop', 'BVA.QUICKSHOP.CLOSE'), (0, _defineProperty3.default)(_animationEnd$animati, 'toggleQuickshop', 'BVA.QUICKSHOP.TOGGLE'), (0, _defineProperty3.default)(_animationEnd$animati, 'updateSliderSlide', 'BVA.SLIDER.UPDATE'), (0, _defineProperty3.default)(_animationEnd$animati, 'updateContainerSliders', 'BVA.CONTAINER.SLIDERS.UPDATE'), _animationEnd$animati);